import { render, staticRenderFns } from "./WechatLandmark.vue?vue&type=template&id=28145d5d&scoped=true&"
import script from "./WechatLandmark.vue?vue&type=script&lang=js&"
export * from "./WechatLandmark.vue?vue&type=script&lang=js&"
import style0 from "./WechatLandmark.vue?vue&type=style&index=0&id=28145d5d&scoped=true&lang=css&"
import style1 from "./WechatLandmark.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28145d5d",
  null
  
)

export default component.exports